import {NgModule} from '@angular/core';
import {IgDashboardComponent} from "./page/dashboard/ig-dashboard.component";
import {IgConfigPage} from "./page/overview/ig-config/ig-config.page";
import {IG_ENTITY_PROVIDER} from "./ig.entity-provider";
import {CoreModule} from "../../core/core.module";
import {IG_TEST_PROVIDERS} from "./test/ig-test-definition";


@NgModule({
  declarations: [
    IgDashboardComponent,
    IgConfigPage,
  ],
  exports:[
    IgDashboardComponent,
    IgConfigPage,
  ],
  imports: [
    CoreModule,

  ],
  providers: [IG_ENTITY_PROVIDER, IG_TEST_PROVIDERS]
})
export class IgModule { }
 
 
 
